import { render } from "./DesktopMenuItemSpacer.vue?vue&type=template&id=ee8d9e58"
import script from "./DesktopMenuItemSpacer.vue?vue&type=script&lang=js"
export * from "./DesktopMenuItemSpacer.vue?vue&type=script&lang=js"

import "./DesktopMenuItemSpacer.vue?vue&type=style&index=0&id=ee8d9e58&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__